import { Link } from 'react-router-dom';
import ErrorPage from '@/components/errors/ErrorPage';

export default function Unauthorized() {
  return (
    <ErrorPage
      code="401"
      emoji="🔑"
      title="Authentication required"
      description="Your session is missing, expired, or invalid."
      details="Sign in again with a valid admin token to continue."
      actions={<Link className="btn btn-primary" to="/login">Go to Login</Link>}
    />
  );
}
